/**
 * Citation Intelligence Contract — Phase 4.
 *
 * BACKEND ALIGNMENT:
 * - All response types derived from generated Zod schemas (OpenAPI-first)
 * - Request types are hand-written (frontend-composed)
 *
 * MIGRATION NOTE:
 * Zod schemas are re-exported from auto-generated code (@hey-api/openapi-ts).
 */

import { z } from 'zod';

// ─── Re-exported generated schemas ──────────────────────────────────────────

import {
  zCitationEntryRead as GeneratedCitationEntryRead,
  zCitationGraphRead as GeneratedCitationGraphRead,
  zCoCitationPairRead as GeneratedCoCitationPairRead,
  zCoCitationListRead as GeneratedCoCitationListRead,
  zTopCoCitationListRead as GeneratedTopCoCitationListRead,
  zRecommendationRead as GeneratedRecommendationRead,
  zRecommendationListRead as GeneratedRecommendationListRead,
  zContradictionPairRead as GeneratedContradictionPairRead,
  zContradictionListRead as GeneratedContradictionListRead,
  zContradictionSummary as GeneratedContradictionSummary,
  zResearchGapRead as GeneratedResearchGapRead,
  zResearchGapListRead as GeneratedResearchGapListRead,
  zResearchGapSummary as GeneratedResearchGapSummary,
} from '@/api/generated/hey-api/zod.gen';

// Task 4.1 — Citation Graph
export const CitationEntryReadSchema = GeneratedCitationEntryRead;
export type CitationEntryRead = z.infer<typeof CitationEntryReadSchema>;

export const CitationGraphReadSchema = GeneratedCitationGraphRead;
export type CitationGraphRead = z.infer<typeof CitationGraphReadSchema>;

// Task 4.2 — Co-citation
export const CoCitationPairReadSchema = GeneratedCoCitationPairRead;
export type CoCitationPairRead = z.infer<typeof CoCitationPairReadSchema>;

export const CoCitationListReadSchema = GeneratedCoCitationListRead;
export type CoCitationListRead = z.infer<typeof CoCitationListReadSchema>;

// Task 4.2b — Workspace-level co-citations (Library knowledge surface)
export const TopCoCitationListReadSchema = GeneratedTopCoCitationListRead;
export type TopCoCitationListRead = z.infer<typeof TopCoCitationListReadSchema>;

// Task 4.3 — Recommendations
export const RecommendationReadSchema = GeneratedRecommendationRead;
export type RecommendationRead = z.infer<typeof RecommendationReadSchema>;

export const RecommendationListReadSchema = GeneratedRecommendationListRead;
export type RecommendationListRead = z.infer<typeof RecommendationListReadSchema>;

// ─── Task 5.3 — Contradiction Detection ──────────────────────────────────────

export const ContradictionPairReadSchema = GeneratedContradictionPairRead;
export type ContradictionPairRead = z.infer<typeof ContradictionPairReadSchema>;

export const ContradictionListReadSchema = GeneratedContradictionListRead;
export type ContradictionListRead = z.infer<typeof ContradictionListReadSchema>;

export const ContradictionSummarySchema = GeneratedContradictionSummary;
export type ContradictionSummary = z.infer<typeof ContradictionSummarySchema>;

// ─── Task 5.4 — Research Gap Detection ───────────────────────────────────────

export const ResearchGapReadSchema = GeneratedResearchGapRead;
export type ResearchGapRead = z.infer<typeof ResearchGapReadSchema>;

export const ResearchGapListReadSchema = GeneratedResearchGapListRead;
export type ResearchGapListRead = z.infer<typeof ResearchGapListReadSchema>;

export const ResearchGapSummarySchema = GeneratedResearchGapSummary;
export type ResearchGapSummary = z.infer<typeof ResearchGapSummarySchema>;

// ─── Hand-written: request types ────────────────────────────────────────────

export interface RecommendationRequestParams {
  documentIds: string[];
}
